import translate from '@insite/client-framework/Translate';
import Typography from '@insite/mobius/Typography';
import React from 'react';

interface Props {
  ReplacementPartNumber: string;
}

function ReplacementPart({ ReplacementPartNumber }: Props) {
  if (!ReplacementPartNumber) {
    return;
  }
  return (
    <>
      <br />
      <Typography>
        {translate("Replaced by ")} <strong>{ReplacementPartNumber.toUpperCase()}</strong>
      </Typography>
    </>

  );
}

export default ReplacementPart;
